import React, { useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { BrandMidnightContestManageContainer } from './contestManage/BrandMidnightContestManageContainer';
import { useManageContestPage } from './contestManage/useManageContestPage';
import { BRAND_LUXE_PRIMARY } from './brandDashboardTokens';
import { ROUTES } from '../../types/global/routes.types';
import { RootState } from '../../redux/root-reducer';
import { isContestDeleted } from '../../redux/contest/deletedContestIds';

export default function BrandContestManagePage() {
    const { contestId } = useParams<{ contestId: string }>();
    const navigate = useNavigate();
    const deletedContestIds = useSelector((s: RootState) => s.contest.deletedContestIds);
    const manage = useManageContestPage();

    useEffect(() => {
        if (contestId && isContestDeleted(contestId, deletedContestIds)) {
            navigate(`${ROUTES.BRAND_CAMPAIGNS}?tab=contest`, { replace: true });
        }
    }, [contestId, deletedContestIds, navigate]);

    if (manage.isContestDetailLoading) {
        return (
            <MetaTags title="Campaign | Brand" description="Contest campaign">
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 12 }}>
                    <CircularProgress sx={{ color: BRAND_LUXE_PRIMARY }} />
                </Box>
            </MetaTags>
        );
    }

    return (
        <MetaTags
            title={`${manage.managedContest?.contest?.title || 'Campaign'} | Brand`}
            description={manage.managedContest?.contest?.description || ''}>
            <BrandMidnightContestManageContainer
                contest={manage.managedContest?.contest ?? null}
                managedContest={manage.managedContest ?? null}
                loading={manage.isContestDetailLoading}
                error={manage.managedContestError}
                onRefresh={() => void manage.getData()}
                onClearError={manage.handleClearError}
                contestManageHandlers={{
                    submissionPagination: manage.submissionPagination,
                    salePagination: manage.salePagination,
                    sortOrder: manage.sortOrder,
                    onSearch: manage.handleSearch,
                    onSort: manage.handleSort,
                    onSortBy: manage.setSortBy,
                    onStartDateChange: manage.handleStartDateChange,
                    onEndDateChange: manage.handleEndDateChange,
                    onClearStartDate: manage.handleClearStartDate,
                    onClearEndDate: manage.handleClearEndDate,
                    onSubmissionRowsChange: manage.handleSubmissionRowsChange,
                    onSubmissionPageChange: manage.handleSubmissionPageChange,
                    onSaleRowsChange: manage.handleSaleRowsChange,
                    onSalePageChange: manage.handleSalePageChange,
                    onSortOrderChange: manage.handleSortOrderChange,
                    onExportCSV: manage.handleExportCSV,
                    onClearSearch: manage.handleClearSearch,
                    onClearAllFilters: manage.handleClearAllFilters,
                    onSaveChanges: manage.handleOnSaveChanges,
                    onProvisionCategories: manage.handleProvisionCategories,
                    onDeleteAwardCategory: manage.handleDeleteAwardCategory,
                    updatingContest: manage.updatingContest,
                }}
            />
        </MetaTags>
    );
}
